module.exports = __webpack_public_path__ + "static/media/sc8r_16.e24efdf4.png";